// extracted by mini-css-extract-plugin
export default {"contentContainer":"App_contentContainer__3gsZa","mainNavigation":"App_mainNavigation__4sq3F","logo":"App_logo__7Edbg"};